<template>
  <v-card flat>
    <v-card-title>
      <span class="d-none d-sm-flex">Checklist entries</span>
      <v-spacer></v-spacer>
      <!-- <h6>History</h6> -->
      <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-show="!entriesHistoryShowNumber"
              v-bind="attrs"
              v-on="on"
              @click="entriesHistoryShow"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Show history</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-show="!!entriesHistoryShowNumber"
              v-bind="attrs"
              v-on="on"
              @click="entriesHistoryHide"
            >
              <v-icon>mdi-eye-off</v-icon>
            </v-btn>
          </template>
          <span>Hide history</span>
        </v-tooltip> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <!-- id="timestampFilter" -->
          <v-btn
            text
            v-show="!!entriesHistoryShowTimestamp"
            v-bind="attrs"
            v-on="on"
            class="text--secondary"
            @click="entriesHistoryTimestampFilterDisable"
          >
            <v-icon left>mdi-filter-remove-outline</v-icon>
            <sl-time :time="entriesHistoryShowTimestamp" dateOnly></sl-time>
          </v-btn>
        </template>
        <span>Remove date filter</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-show="!!entriesHistoryShowNumber"
            v-bind="attrs"
            v-on="on"
            @click="entriesHistoryShowMore"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Show more history items</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-show="!!entriesHistoryShowNumber"
            v-bind="attrs"
            v-on="on"
            @click="entriesHistoryShowLess"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </template>
        <span>Show less history items</span>
      </v-tooltip>
      <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="entriesHistoryShowToggle">
              <v-icon>{{ !!entriesHistoryShowNumber ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
            </v-btn>
          </template>
          <span>{{ !!entriesHistoryShowNumber ? 'Hide history' : 'Show history' }}</span>
        </v-tooltip> -->
      <v-tooltip bottom>
        <template #activator="{ on: tooltip, attrs }">
          <span v-on="{ ...tooltip }">
            <v-btn
              :disabled="!entriesHistorySome"
              outlined
              v-bind="attrs"
              @click="entriesHistoryShowToggle"
            >
              <v-icon left>{{
                !!entriesHistoryShowNumber ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
              }}</v-icon>
              {{ !!entriesHistoryShowNumber ? 'Hide history' : 'Show history' }}
            </v-btn>
          </span>
        </template>
        <span v-if="!entriesHistorySome">No entries history to show yet</span>
        <span v-else>Show and restore deleted and modified entries</span>
      </v-tooltip>
    </v-card-title>
    <draggable
      v-model="master.clEntries"
      v-bind="dragOptions"
      handle=".handle"
      @start="entryOnStartDragging"
      @end="entryOnEndDragging"
    >
      <transition-group type="transition" :name="dragging ? null : 'flip-list'">
        <sl-entry
          v-for="(entry, index) in master.clEntries"
          :ref="'ENTRY' + index"
          :key="entry.historyKey"
          :entry="entry"
          :master="master"
          :index="index"
          :disabled="entryDisabledRules"
          :historyItemsRequested="entriesHistoryShowNumber"
          :historyTimestampRequested="entriesHistoryShowTimestamp"
          @historyTimestampFilter="entriesHistoryTimestampFilterEnable($event)"
          @goto-next="onGotoNext(index)"
          draggable
        >
        </sl-entry>
      </transition-group>
    </draggable>
    <sl-entry
      ref="newEntry"
      @entry-created="onEntryCreated($event)"
      addNew
      :master="master"
      :disabled="entryDisabledRules"
    >
    </sl-entry>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import draggable from 'vuedraggable'

import ClMaster from '@/models/ClMaster'

import SlEntry from '@/components/SlEntry'
import SlTime from '@/components/SlTime'

export default {
  components: {
    draggable,
    SlEntry,
    SlTime,
  },

  props: {
    master: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dragging: false,
      entriesHistoryShowNumber: 0,
      entriesHistoryShowStep: 3,
      entriesHistoryShowTimestamp: '',
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      },
    }
  },

  computed: {
    //
    entryDisabledRules() {
      return {
        adding: !this.master.actionsAllowed?.entryCreate,
        checking: true,
        dragging: false,
        editing: false,
      }
    },
    entriesHistorySome() {
      const history = element => element.history && element.history.length
      return this.master.clEntries.some(history)
    },
    entriesHistoryMax() {
      const historyLength = element => element.history?.length
      return Math.max(...this.master.clEntries.map(historyLength))
    },
    /* dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    }, */
    ...mapState(['userLogged']),
  },

  created() {
    //
  },

  mounted() {
    if (this.master.clEntries.length == 0) {
      this.setFocus() // lo faccio solo se è vuoto perché altrimenti scrolla verso il basso
    }
    //
  },

  beforeDestroy() {
    //
  },

  methods: {
    setFocus() {
      this.$refs['newEntry'].textFocus()
    },

    onGotoNext(index) {
      const nextIndex = index + 1
      if (this.$refs['ENTRY' + nextIndex]) {
        this.$refs['ENTRY' + nextIndex][0].textFocus()
      } else {
        this.$refs['newEntry'].textFocus()
      }
    },

    onEntryCreated() {
      this.$vuetify.goTo(this.$refs.newEntry, {
        duration: 300,
        offset: 50,
        easing: 'easeInOutCubic',
      })
    },
    entriesHistoryShowToggle() {
      if (this.entriesHistoryShowNumber) {
        this.entriesHistoryTimestampFilterDisable()
        // this.entriesHistoryShowTimestamp = ''
        this.entriesHistoryShowNumber = 0
      } else {
        this.entriesHistoryShowNumber = this.entriesHistoryShowStep
      }
    },
    entriesHistoryShowMore() {
      this.entriesHistoryShowNumber += Math.min(
        this.entriesHistoryMax - this.entriesHistoryShowNumber,
        this.entriesHistoryShowStep,
      )
    },
    entriesHistoryShowLess() {
      this.entriesHistoryShowNumber -= Math.min(
        this.entriesHistoryShowNumber,
        this.entriesHistoryShowStep,
      )
    },
    entriesHistoryTimestampFilterEnable(timestamp) {
      // Logger.debug('Filter timestamp:', timestamp)
      this.entriesHistoryShowTimestamp = timestamp
    },
    entriesHistoryTimestampFilterDisable() {
      this.entriesHistoryShowTimestamp = ''
    },
    /* entryShow(entry) {
      return !entry.deleted || !!this.entriesHistoryShowNumber
    }, */
    // async entryMove() {},
    async entryMove(entryId, oldIndex, newIndex) {
      try {
        await ClMaster.entryMove(entryId, oldIndex, newIndex)
      } catch (e) {
        Logger.error(e)
        this.toastSet({
          message: 'Error in changing entry order',
          color: 'error',
        })
        // FIXME: riporta indietro il move
      }
    },
    entryOnStartDragging() {
      this.dragging = true
    },
    entryOnEndDragging(evt) {
      this.dragging = false
      Logger.debug('Moving event:', evt)
      if (evt.oldIndex !== evt.newIndex) {
        const entryMovedId = this.master.clEntries[evt.newIndex].id
        this.entryMove(entryMovedId, evt.oldIndex, evt.newIndex)
      }
    },
    ...mapMutations(['toastSet']),
  },
}
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.38;
  /* background: #c8ebfb; */
}
#timestampFilter {
  opacity: 0.6;
  text-decoration: line-through;
}
</style>
